import { defineMessages } from 'react-intl';

export const ROOM_IMAGES_CDN = 'https://a.1stdibscdn.com/cdnmisc/roomimages';

const getImageUrl = image => {
    return `${ROOM_IMAGES_CDN}/${image}?format=jpeg&quality=80`;
};

export const ROOM_MESSAGES = defineMessages({
    livingRoom: {
        id: 'sb.roomTiles.living-room',
        defaultMessage: 'Living Room',
    },
    diningRoom: {
        id: 'sb.roomTiles.dining-room',
        defaultMessage: 'Dining Room',
    },
    kitchen: {
        id: 'sb.roomTiles.Kitchen',
        defaultMessage: 'Kitchen',
    },
    bedroom: {
        id: 'sb.roomTiles.bedroom',
        defaultMessage: 'Bedroom',
    },
    officeAndStudy: {
        id: 'sb.roomTiles.office-and-study',
        defaultMessage: 'Office and Study',
    },
});

export const ROOM_TILES = [
    {
        displayName: ROOM_MESSAGES.livingRoom,
        url: '/furniture/room/living-room/',
        image: getImageUrl('living_room2x.png'),
    },
    {
        displayName: ROOM_MESSAGES.diningRoom,
        url: '/furniture/room/dining-room/',
        image: getImageUrl('dining_room2x.png'),
    },
    {
        displayName: ROOM_MESSAGES.kitchen,
        url: '/furniture/room/kitchen/',
        image: getImageUrl('kitchen2x.png'),
    },
    {
        displayName: ROOM_MESSAGES.bedroom,
        url: '/furniture/room/bedroom/',
        image: getImageUrl('bedroom2x.png'),
    },
    {
        displayName: ROOM_MESSAGES.officeAndStudy,
        url: '/furniture/room/office-study/',
        image: getImageUrl('office_and_study2x.png'),
    },
];
